var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from '@mui/icons-material';
import { Autocomplete, Badge, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormHelperText, Grid, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, TextField, Typography, useTheme } from '@mui/material';
import { ArrowLeft02Icon, ArrowRight03Icon, Unlink05Icon } from 'hugeicons-react';
import { enqueueSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { X } from 'react-feather';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { useLazyGetModelsQuery, useUpdateClientMachineMutation, useUpdateSerialNumberMutation } from '../../../../../application/features/machines/machine-api';
import useTranslate from '../../../../../localization/helpers';
import ReAssignSerial from '../../../../components/ReAssignSerial';
import EditSerialNumbers from './EditSerialNumbers';
var EditSerialNumber = function (_a) {
    var _b;
    var open = _a.open, onClose = _a.onClose, machineId = _a.machineId, modelNumber = _a.modelNumber;
    var theme = useTheme();
    var _c = useTranslate(), translate = _c.translate, tWithField = _c.tWithField, tWithFunction = _c.tWithFunction;
    var _d = __read(useState(null), 2), anchorEl = _d[0], setAnchorEl = _d[1];
    var _e = __read(useState(false), 2), menuRowId = _e[0], setMenuRowId = _e[1];
    var _f = __read(useState('edit'), 2), viewMode = _f[0], setViewMode = _f[1];
    var _g = __read(useState([]), 2), selectedSerials = _g[0], setSelectedSerials = _g[1];
    var _h = __read(useState(false), 2), selectAll = _h[0], setSelectAll = _h[1];
    var handleMenuClose = function () {
        setAnchorEl(null);
        setMenuRowId(false);
    };
    var _j = __read(useLazyGetModelsQuery(), 2), getMachineModels = _j[0], _k = _j[1], machine = _k.data, isMachineModelFetching = _k.isFetching;
    var _l = __read(useUpdateSerialNumberMutation(), 2), updateSerialNumbers = _l[0], _m = _l[1], isLoading = _m.isLoading, isSuccess = _m.isSuccess;
    var _o = __read(useUpdateClientMachineMutation(), 2), triggerUpdateClientMachine = _o[0], _p = _o[1], isUpdateClientMachineLoading = _p.isLoading, isUpdateClientMachineSuccess = _p.isSuccess;
    var filteredModels = machine === null || machine === void 0 ? void 0 : machine.models.filter(function (x) { return x.modelNumber === modelNumber; });
    var hasNullClient = filteredModels === null || filteredModels === void 0 ? void 0 : filteredModels.some(function (m) { return m.clientId === null; });
    var clients = __spreadArray(__spreadArray([], __read((hasNullClient ? [{ id: null, name: translate('common.noClients') }] : [])), false), __read(new Map(filteredModels === null || filteredModels === void 0 ? void 0 : filteredModels.map(function (m) { return [m.clientId, { id: m.clientId, name: m.clientName }]; })).values()), false);
    var _q = useForm({
        defaultValues: {
            machineId: '',
            machineData: [
                {
                    modelNumber: '',
                    serialNumbers: [
                        {
                            serialNumber: ''
                        }
                    ]
                }
            ]
        }
    }), control = _q.control, reset = _q.reset, getValues = _q.getValues, watch = _q.watch, setValue = _q.setValue, clearErrors = _q.clearErrors, setError = _q.setError, handleSubmit = _q.handleSubmit, errors = _q.formState.errors;
    var updateClientMachineForm = useForm({
        defaultValues: {
            clientId: null,
            modelNumber: '',
            serialNumbers: [],
            machineId: '',
            oldClientId: null
        }
    });
    var fields = useFieldArray({
        name: 'machineData',
        control: control
    }).fields;
    var clientId = watch('clientId');
    var serialNumbers = ((_b = filteredModels === null || filteredModels === void 0 ? void 0 : filteredModels.find(function (x) { return x.clientId === clientId; })) === null || _b === void 0 ? void 0 : _b.serialNumbers) || [];
    var totalSerials = serialNumbers.length;
    var reAssignClients = clients.filter(function (client) { return client.id !== null && client.id !== clientId; });
    var handleMenuClick = function (event) {
        setAnchorEl(event.currentTarget);
        setMenuRowId(true);
    };
    useEffect(function () {
        if (machineId)
            getMachineModels(machineId);
    }, [machineId, getMachineModels]);
    useEffect(function () {
        if (clientId === null || (clientId && filteredModels)) {
            var clientModels = filteredModels === null || filteredModels === void 0 ? void 0 : filteredModels.filter(function (m) { return m.clientId === clientId; });
            var machineData = clientModels === null || clientModels === void 0 ? void 0 : clientModels.map(function (model) {
                return ({
                    modelNumber: model.modelNumber,
                    serialNumbers: model.serialNumbers.map(function (serialNumber) { return ({ serialNumber: serialNumber }); }),
                    deletedSerialNumbers: []
                });
            });
            if (machineData)
                setValue('machineData', machineData, { shouldValidate: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientId, setValue]);
    useEffect(function () {
        if (isSuccess || isUpdateClientMachineSuccess) {
            enqueueSnackbar(tWithField('toolTips.updateSuccess', 'common.record'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
            closeDialog();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess, isUpdateClientMachineSuccess]);
    var closeDialog = function () {
        reset();
        updateClientMachineForm.reset();
        setSelectedSerials([]);
        setSelectAll(false);
        setViewMode('edit');
        onClose();
    };
    var handleReAssignClick = function () {
        setViewMode('reassign');
        handleMenuClose();
    };
    var handleDeLinkClick = function () {
        setViewMode('delink');
        handleMenuClose();
    };
    var handleBackToEdit = function () {
        setViewMode('edit');
        setSelectedSerials([]);
        setSelectAll(false);
        updateClientMachineForm.reset();
        getMachineModels(machineId);
    };
    var handleReassignSubmit = function (reassignClient) {
        reassignClient.modelNumber = modelNumber;
        reassignClient.machineId = machineId;
        reassignClient.serialNumbers = selectedSerials;
        if (clientId)
            reassignClient.oldClientId = clientId;
        triggerUpdateClientMachine(reassignClient);
    };
    var handleDelinkSubmit = function (delinkClient) {
        delinkClient.modelNumber = modelNumber;
        delinkClient.machineId = machineId;
        delinkClient.serialNumbers = selectedSerials;
        delinkClient.clientId = null;
        if (clientId)
            delinkClient.oldClientId = clientId;
        triggerUpdateClientMachine(delinkClient);
    };
    var findDuplicateSerialNumber = function (machineData) {
        var e_1, _a, e_2, _b, e_3, _c;
        var allSerialNumbers = machineData.flatMap(function (model, modelIndex) {
            return model.serialNumbers.map(function (s, serialIndex) { return ({
                serialNumber: s.serialNumber.trim().toLowerCase(),
                modelIndex: modelIndex,
                serialIndex: serialIndex
            }); });
        });
        var serialNumberMap = new Map();
        try {
            for (var allSerialNumbers_1 = __values(allSerialNumbers), allSerialNumbers_1_1 = allSerialNumbers_1.next(); !allSerialNumbers_1_1.done; allSerialNumbers_1_1 = allSerialNumbers_1.next()) {
                var _d = allSerialNumbers_1_1.value, serialNumber = _d.serialNumber, modelIndex = _d.modelIndex, serialIndex = _d.serialIndex;
                if (!serialNumberMap.has(serialNumber)) {
                    serialNumberMap.set(serialNumber, []);
                }
                serialNumberMap.get(serialNumber).push({ modelIndex: modelIndex, serialIndex: serialIndex });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (allSerialNumbers_1_1 && !allSerialNumbers_1_1.done && (_a = allSerialNumbers_1.return)) _a.call(allSerialNumbers_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var hasDuplicates = false;
        try {
            for (var _e = __values(serialNumberMap.values()), _f = _e.next(); !_f.done; _f = _e.next()) {
                var occurrences = _f.value;
                if (occurrences.length > 1) {
                    hasDuplicates = true;
                    try {
                        for (var occurrences_1 = (e_3 = void 0, __values(occurrences)), occurrences_1_1 = occurrences_1.next(); !occurrences_1_1.done; occurrences_1_1 = occurrences_1.next()) {
                            var _g = occurrences_1_1.value, modelIndex = _g.modelIndex, serialIndex = _g.serialIndex;
                            setError("machineData.".concat(modelIndex, ".serialNumbers.").concat(serialIndex, ".serialNumber"), {
                                message: tWithField('validations.isUnique', 'assets.serialNumber')
                            });
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (occurrences_1_1 && !occurrences_1_1.done && (_c = occurrences_1.return)) _c.call(occurrences_1);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return !hasDuplicates;
    };
    var handleSubmitForm = function (updatedMachine) {
        var e_4, _a;
        var isValid = findDuplicateSerialNumber(updatedMachine.machineData);
        if (isValid) {
            updatedMachine.machineId = machineId;
            var machineModel = filteredModels === null || filteredModels === void 0 ? void 0 : filteredModels.find(function (m) { return m.clientId === updatedMachine.clientId; });
            var _loop_1 = function (machineData) {
                var machineSerialNumbers = new Set(machineData.serialNumbers.map(function (sr) { return sr.serialNumber; }));
                machineData.deletedSerialNumbers = machineModel === null || machineModel === void 0 ? void 0 : machineModel.serialNumbers.filter(function (sr) { return !machineSerialNumbers.has(sr); });
            };
            try {
                for (var _b = __values(updatedMachine.machineData), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var machineData = _c.value;
                    _loop_1(machineData);
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_4) throw e_4.error; }
            }
            var prevSerialNumbers_1 = (machineModel === null || machineModel === void 0 ? void 0 : machineModel.serialNumbers) || [];
            var currentSerialNumbers = updatedMachine.machineData.flatMap(function (md) {
                return md.serialNumbers.map(function (sn) { return sn.serialNumber; });
            });
            updatedMachine.addedSerialNumbers = currentSerialNumbers.filter(function (sn) { return !prevSerialNumbers_1.includes(sn); });
            if (!updatedMachine.machineData.map(function (x) { return x.modelNumber; }).includes(machineModel === null || machineModel === void 0 ? void 0 : machineModel.modelNumber)) {
                updatedMachine.oldModelNumber = machineModel === null || machineModel === void 0 ? void 0 : machineModel.modelNumber;
            }
            if (hasNullClient)
                updatedMachine.hasNullClient = hasNullClient;
            updateSerialNumbers(updatedMachine);
        }
    };
    var renderEditContent = function () { return (_jsxs(_Fragment, { children: [_jsx(Box, { component: 'form', noValidate: true, autoComplete: 'off', children: _jsx(Grid, { container: true, spacing: 3, p: 1, children: _jsx(Grid, { size: { xs: 12, md: 12, sm: 12, lg: 12 }, children: _jsx(Controller, { name: 'clientId', control: control, render: function (_a) {
                                var _b = _a.field, onChange = _b.onChange, value = _b.value;
                                return (_jsx(FormControl, { size: 'medium', fullWidth: true, variant: 'outlined', children: _jsx(Autocomplete, { sx: {
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '8px'
                                            }
                                        }, loading: isMachineModelFetching, disabled: isLoading, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, value: clients.find(function (client) { return value === client.id; }) || null, options: clients || [], getOptionLabel: function (option) { return option.name; }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { disabled: isLoading, error: !!errors.clientId, variant: 'outlined', fullWidth: true, label: translate('common.client') }))); }, onChange: function (_, value) {
                                            onChange(value === null || value === void 0 ? void 0 : value.id);
                                        }, renderOption: function (props, option) {
                                            return option !== null && (_createElement("li", __assign({}, props, { key: option.id }), option.name));
                                        }, noOptionsText: translate('common.noClients') }) }));
                            } }) }) }) }), (clientId === null || clientId) && (_jsxs(Box, { mt: 1, display: 'flex', flexDirection: 'column', gap: '16px', children: [_jsx(Box, { display: 'flex', justifyContent: 'space-between', width: '100%', children: _jsx(Typography, { variant: 'subtitle1', color: theme.palette.grey[700], children: translate('assets.modelNumber') }) }), fields.map(function (field, index) { return (_jsx(Grid, { container: true, spacing: 2, children: _jsx(Grid, { size: { xs: 12 }, children: _jsxs(Box, { p: '8px 16px', gap: 2, flexDirection: 'column', borderRadius: '12px', bgcolor: '#FFFFFF', boxShadow: theme.customShadows.z8, position: 'relative', children: [_jsx(Badge, { overlap: 'circular', badgeContent: index + 1, sx: {
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            zIndex: 10,
                                            '& .MuiBadge-badge': {
                                                backgroundColor: '#E4E6EB',
                                                color: '#161C24'
                                            }
                                        } }), _jsxs(Box, { display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1, children: [_jsx(Controller, { name: "machineData.".concat(index, ".modelNumber"), control: control, rules: {
                                                    required: tWithField('validations.fieldIsRequired', 'assets.modelNumber'),
                                                    validate: function (value) {
                                                        var isDuplicate = fields.some(function (item, i) {
                                                            return i !== index && item.modelNumber.toLowerCase() === value.toLowerCase();
                                                        });
                                                        return isDuplicate
                                                            ? tWithField('validations.isUnique', 'assets.modelNumber')
                                                            : true;
                                                    }
                                                }, render: function (_a) {
                                                    var _b, _c, _d, _e, _f, _g, _h;
                                                    var field = _a.field;
                                                    return (_jsxs(FormControl, { fullWidth: true, error: !!((_c = (_b = errors.machineData) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.modelNumber), children: [_jsx(Box, { display: 'flex', justifyContent: 'space-between', gap: 1, children: _jsx(TextField, __assign({ size: 'small', disabled: isLoading, label: translate('common.modelNumber') }, field, { error: !!((_e = (_d = errors.machineData) === null || _d === void 0 ? void 0 : _d[index]) === null || _e === void 0 ? void 0 : _e.modelNumber), fullWidth: true, children: translate('assets.modelNumber') })) }), _jsx(FormHelperText, { error: true, children: (_h = (_g = (_f = errors.machineData) === null || _f === void 0 ? void 0 : _f[index]) === null || _g === void 0 ? void 0 : _g.modelNumber) === null || _h === void 0 ? void 0 : _h.message })] }));
                                                } }), _jsx(Box, { children: _jsx(Button, { variant: 'outlined', color: 'inherit', disabled: isLoading || serialNumbers.length === 0, size: 'medium', onClick: function (event) { return handleMenuClick(event); }, endIcon: anchorEl ? (_jsx(KeyboardArrowUpOutlined, { sx: { fontSize: 24 } })) : (_jsx(KeyboardArrowDownOutlined, { sx: { fontSize: 24 } })), children: translate('assets.options') }) }), _jsxs(Menu, { anchorEl: anchorEl, open: menuRowId, onClose: handleMenuClose, anchorOrigin: {
                                                    vertical: 'bottom',
                                                    horizontal: 'center'
                                                }, transformOrigin: {
                                                    vertical: 'top',
                                                    horizontal: 'center'
                                                }, children: [_jsxs(MenuItem, { disabled: reAssignClients.length === 0, onClick: handleReAssignClick, children: [_jsx(ListItemIcon, { children: _jsx(ArrowRight03Icon, { color: '#637381', fontSize: 'small' }) }), _jsx(ListItemText, { sx: { color: 'inherit' }, children: translate('assets.reassign') })] }), _jsx(Divider, {}), _jsxs(MenuItem, { disabled: clientId === null, onClick: handleDeLinkClick, children: [_jsx(ListItemIcon, { children: _jsx(Unlink05Icon, { color: '#637381', fontSize: 'small' }) }), _jsx(ListItemText, { children: translate('assets.delink') })] })] })] }), _jsx(EditSerialNumbers, { control: control, modelSerialNumberIndex: index, errors: errors, isLoading: isLoading })] }) }) }, field.id)); })] }))] })); };
    return (_jsxs(Dialog, { sx: { borderRadius: '44px' }, fullWidth: true, scroll: 'paper', open: open, maxWidth: 'sm', children: [_jsxs(DialogTitle, { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontSize: '20px',
                    padding: '16px 24px'
                }, children: [viewMode === 'edit' ? (tWithFunction('actions.updateFunction', 'assets.modelSerialNumbers')) : (_jsxs(Box, { display: 'flex', alignItems: 'center', gap: 1, children: [_jsx(IconButton, { size: 'Xs', color: 'primary', onClick: handleBackToEdit, sx: { p: 0 }, children: _jsx(ArrowLeft02Icon, { size: 20, color: theme.palette.primary.main }) }), _jsx(Typography, { variant: 'h6', component: 'div', children: translate(viewMode === 'reassign'
                                    ? 'assets.reAssignModelSerials'
                                    : 'assets.deLinkModelSerials') })] })), _jsx(IconButton, { color: 'inherit', style: { marginLeft: 'auto' }, onClick: closeDialog, children: _jsx(X, { size: 20, color: '#637381' }) })] }), _jsx(DialogContent, { dividers: true, sx: {
                    pb: 4,
                    px: 4
                }, children: viewMode === 'edit' ? (renderEditContent()) : (_jsx(ReAssignSerial, { viewMode: viewMode, form: updateClientMachineForm, clients: reAssignClients, serialNumbers: serialNumbers, totalSerials: totalSerials, modelNumber: modelNumber, isLoading: isUpdateClientMachineLoading, selectedSerials: selectedSerials, setSelectedSerials: setSelectedSerials, selectAll: selectAll, setSelectAll: setSelectAll, translate: translate })) }), _jsxs(DialogActions, { children: [_jsx(Button, { size: 'medium', variant: 'outlined', color: 'inherit', disabled: viewMode === 'edit' ? isLoading : isUpdateClientMachineLoading, onClick: closeDialog, children: translate('actions.cancel') }), viewMode === 'edit' ? (_jsx(Button, { size: 'medium', variant: 'contained', color: 'warning', disabled: isLoading, onClick: handleSubmit(handleSubmitForm), children: translate('actions.saveChanges') })) : viewMode === 'reassign' ? (_jsxs(Button, { size: 'medium', variant: 'contained', color: 'warning', disabled: isUpdateClientMachineLoading || selectedSerials.length === 0, onClick: updateClientMachineForm.handleSubmit(handleReassignSubmit), children: [translate('assets.reAssignAll'), " (", selectedSerials.length, ")"] })) : (_jsxs(Button, { size: 'medium', variant: 'contained', color: 'warning', disabled: isUpdateClientMachineLoading || selectedSerials.length === 0, onClick: updateClientMachineForm.handleSubmit(handleDelinkSubmit), children: [translate('assets.deLinkAll'), " (", selectedSerials.length, ")"] }))] })] }));
};
export default EditSerialNumber;
